const CLIENTID = process.env.REACT_APP_AUTH0_CLIENTID || '4mo4gsLerhkmTevIG11bViKlyGRfWMRw'; // prettier-ignore
const DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN || 'dev-pel0-vrt.eu.auth0.com'; // prettier-ignore
const AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE || 'https://bataillog-api'; // prettier-ignore
const ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'http://localhost:8000'; // prettier-ignore
const SHIPPING_API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || "http://localhost:8082"; // prettier-ignore
const SYNC_API_ENDPOINT = process.env.REACT_APP_API_SYNC || "http://localhost:8081"; // prettier-ignore
const ORDER_API_ENDPOINT = process.env.REACT_APP_ORDER_API_URL || "http://localhost:8081/api"; // prettier-ignore
const INSEE_API_ENDPOINT = "https://api.insee.fr";

export const publicPath = "../public";
export const publicIconPath = "/icons";

export const VFSOLUTIONS = "VF SOLUTIONS";

export default {
  AUTH0: {
    CLIENTID,
    DOMAIN,
    AUDIENCE,
  },
  API: {
    ENDPOINT,
    ENDPOINTS: {
      STOCK: `${ENDPOINT}/api/stock`,
      CATEGORY: {
        GET: `${ENDPOINT}/api/category`,
        ADD: `${ENDPOINT}/api/category`,
        EDIT: `${ENDPOINT}/api/category`,
        DELETE: `${ENDPOINT}/api/category`,
      },
      PRODUCT: {
        ADD: `${ENDPOINT}/api/product`,
        GET: `${ENDPOINT}/api/product`,
        IMPORT: `${ENDPOINT}/api/product/import`,
        RECEPTION: `${ENDPOINT}/api/product/reception`,
        EDIT: `${ENDPOINT}/api/product`,
      },
      USER: {
        VERIFY: `${ENDPOINT}/api/user/verify`,
        VERIFY_SETTING: `${ENDPOINT}/api/user/setting/verify`,
        CHANGE_SETTING: `${ENDPOINT}/api/user/setting`,
        UPDATE: `${ENDPOINT}/api/user/update`,
        USER: `${ENDPOINT}/api/user`,
      },
      USERINFO: `https://${DOMAIN}/userinfo`,
      SEARCH: `${ENDPOINT}/api/search`,
      RESET: `${ENDPOINT}/api/reset`,
      LOGIN: `${ENDPOINT}/api/login`,
      CHECK: `${ENDPOINT}/api/public`,
      PRIVATE: `${ENDPOINT}/api/private`,
      PROTECTED: `${ENDPOINT}/api/private-scoped`,
      REFRESH_TOKEN: `${ENDPOINT}/api/refresh_token`,
      REVOKE: `${ENDPOINT}/api/revoke`,
    },
  },
  SHIPPING_API: {
    ENDPOINT: `${SHIPPING_API_ENDPOINT}/api/shipping`,
  },
  SYNC_API: {
    ENDPOINT: SYNC_API_ENDPOINT,
  },
  ORDER_API: {
    ENDPOINT: ORDER_API_ENDPOINT,
  },
  INSEE_API: {
    SIRENE_ENDPOINT: `${INSEE_API_ENDPOINT}/api-sirene/3.11/siret`,
  },
};

export enum tabs {
  PROVIDER_TAB,
  TRANSFER_TAB,
}

export const SHIPPING_OPS_PER_PAGE = 10;

export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50];
